import { MarkdownContent } from '@/components/markdown-content';
import { Skeleton } from '@/components/ui/skeleton';
import { usePersonaById } from '@/hooks/use-personas';
import { asSummaryText } from '../utils-display';

interface PersonaSummaryContentProps {
	personaId: string;
	/** Set false when an ancestor (e.g. an accordion trigger) already labels this block "Summary". */
	showLabel?: boolean;
}

export function PersonaSummaryContent({ personaId, showLabel = true }: PersonaSummaryContentProps) {
	const { data: persona, isLoading } = usePersonaById(personaId);

	if (isLoading) {
		return (
			<div className='flex flex-col gap-2 px-1'>
				<Skeleton className='h-4 w-24' />
				<Skeleton className='h-3 w-full' />
				<Skeleton className='h-3 w-full' />
				<Skeleton className='h-3 w-3/4' />
			</div>
		);
	}

	// Strip the leading `## Summary` heading — this component already renders its own
	// "Summary" label above the body, so keeping the heading would show it twice.
	const body = asSummaryText(persona?.summary)
		.replace(/^##\s*Summary\s*/i, '')
		.trim();

	if (!body) {
		return <p className='text-xs text-muted-foreground px-1'>No summary generated yet.</p>;
	}

	return (
		<div className='flex flex-col gap-4 px-1'>
			{showLabel && <p className='text-sm font-medium text-muted-foreground'>Summary</p>}
			<MarkdownContent text={body} className='text-xs text-foreground' />
		</div>
	);
}
